var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAltium365Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 896,
    height: 400,
    viewBox: "0 0 896 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.718 338.56C287.718 338.56 329.763 314.406 345.814 305.206C349.603 303.018 351.926 299.005 351.926 294.669C351.926 275.013 351.559 220.91 351.559 220.91L216.422 298.316L287.718 338.56Z",
    fill: "url(#paint0_linear_4371_42559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 227.274V294.225C0 298.561 2.32222 302.573 6.11111 304.762C23.2222 314.61 70.4407 341.317 70.4407 341.317V186.059L0 227.274Z",
    fill: "url(#paint1_linear_4371_42559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.738 34.5293C240.738 34.5293 198.897 10.6995 182.927 1.62154C179.138 -0.526386 174.493 -0.526386 170.745 1.66206C153.634 11.4696 106.375 39.0278 106.375 39.0278L241.349 115.705L240.738 34.5293V34.5293Z",
    fill: "url(#paint2_linear_4371_42559)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.815 78.8247V110.395C176.815 120.446 171.437 129.686 162.718 134.752L12.6704 221.439C5.33704 225.451 0.325926 233.07 0 241.864V109.017C0 103.222 3.0963 97.8723 8.14815 94.9949C39.2333 77.1226 170.744 1.62107 170.744 1.62107C172.618 0.526849 174.737 0 176.815 0V78.8247Z",
    fill: "url(#paint3_linear_4371_42559)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5354 244.58C106.254 239.554 117.05 239.514 125.809 244.499L275.939 330.294C279.728 332.685 284.209 334.063 289.017 334.063C293.824 334.063 297.98 332.766 301.687 330.537C301.687 330.537 212.465 381.844 184.721 397.812C179.669 400.73 173.476 400.73 168.424 397.812C138.358 380.547 5.78727 304.357 5.78727 304.357C3.95393 303.262 2.48727 301.763 1.46875 299.98L18.5799 290.091C18.5799 290.091 30.2724 283.364 36.9132 279.514L97.5354 244.58Z",
    fill: "url(#paint4_linear_4371_42559)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.953 283.811V294.632C351.953 296.78 351.383 298.887 350.323 300.67L281.675 261.035C271.897 255.402 262.079 249.728 253.605 244.824C244.886 239.799 239.549 230.559 239.509 220.589L239.06 48.1072V47.7424C239.06 38.6644 234.049 30.7211 226.594 26.5469C226.594 26.5469 316.06 78.0565 343.846 94.0646C348.897 96.942 351.994 102.292 351.994 108.087L351.953 283.811Z",
    fill: "url(#paint5_linear_4371_42559)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M450.503 181.305H460.157L470.05 158.92H515.46L525.233 181.305H535.364L497.343 96H488.523L450.503 181.305ZM473.744 150.329L492.814 107.132L511.765 150.329H473.744Z",
    fill: "#252A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M551.816 181.305H608.191V172.472H561.232V96.605H551.816V181.305Z",
    fill: "#252A3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M635.787 181.305H645.322V105.438H673.331V96.605H607.778V105.438H635.787V181.305Z",
    fill: "#252A3A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M691.857 181.305H701.272V96.605H691.857V181.305Z",
    fill: "#252A3A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M759.08 182.636C779.937 182.636 793.882 169.81 793.882 145.126V96.605H784.466V145.852C784.466 164.365 774.693 173.803 759.318 173.803C743.347 173.803 733.812 163.518 733.812 145.247V96.605H724.396V145.852C724.396 169.81 738.46 182.636 759.08 182.636Z",
    fill: "#252A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M816.145 181.305H825.322V112.819L855.715 158.073H856.192L886.584 112.698V181.305H896V96.605H886.465L856.072 142.827L825.68 96.605H816.145V181.305Z",
    fill: "#252A3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M483.518 304C502.111 304 515.698 292.989 515.698 275.807V275.565C515.698 261.166 506.044 254.39 494.125 251.728L514.029 234.425V217.606H453.721V236.603H485.663L466.474 254.148L469.811 266.369H479.584C488.285 266.369 493.172 269.636 493.172 275.081V275.323C493.172 280.526 489 283.914 482.445 283.914C474.817 283.914 468.5 280.405 462.541 274.234L448 288.996C456.105 298.071 467.427 304 483.518 304Z",
    fill: "#252A3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M560.523 304C578.759 304 593.657 292.505 593.657 273.508V273.266C593.657 256.326 580.785 246.888 566.125 246.888C557.901 246.888 552.538 250.034 548.128 253.422C549.201 242.774 554.087 235.393 563.86 235.393C570.535 235.393 575.302 237.934 580.427 241.806L591.273 225.229C583.288 219.179 575.183 215.912 563.503 215.912C537.401 215.912 524.767 235.998 524.767 262.376V262.618C524.767 278.469 528.82 288.028 535.017 294.32C540.977 300.37 548.724 304 560.523 304ZM559.57 285.729C552.299 285.729 547.77 280.889 547.77 274.718V274.476C547.77 268.426 552.061 263.707 559.331 263.707C566.602 263.707 571.131 268.547 571.131 274.597V274.839C571.131 281.01 566.84 285.729 559.57 285.729Z",
    fill: "#252A3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M634.909 304C655.17 304 669.354 292.747 669.354 273.871V273.629C669.354 255.237 655.766 246.767 640.749 246.767C635.147 246.767 631.214 247.977 627.4 249.792L628.115 236.966H665.659V217.606H609.88L607.496 260.561L621.202 268.305C625.135 265.885 629.426 264.07 634.551 264.07C641.822 264.07 646.827 267.821 646.827 273.871V274.113C646.827 280.163 642.179 284.035 634.551 284.035C627.519 284.035 621.083 280.647 614.289 274.839L601.06 290.569C609.76 298.797 620.13 304 634.909 304Z",
    fill: "#252A3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4371_42559",
    x1: 326.381,
    y1: 278.207,
    x2: 253.082,
    y2: 294.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1368BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4371_42559",
    x1: 12.6133,
    y1: 228.048,
    x2: 73.6462,
    y2: 269.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1368BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4371_42559",
    x1: 151.133,
    y1: 45.6864,
    x2: 243.81,
    y2: 65.1399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1368BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003E89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4371_42559",
    x1: 150.113,
    y1: 144.831,
    x2: 13.1667,
    y2: 91.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B55D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4371_42559",
    x1: 166.542,
    y1: 280.381,
    x2: 129.849,
    y2: 366.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B55D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4371_42559",
    x1: 351.399,
    y1: 119.641,
    x2: 238.571,
    y2: 199.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B55D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltium365Logo);
export default __webpack_public_path__ + "static/media/altium365_logo.2972ddf4def5c0a7b3e2769c599b6e45.svg";
export { ForwardRef as ReactComponent };